<template>
  <div>
    <div class="jc-container-table">
      <div class="jc-container-table-actionBar">
        <jc-form class="jc-table-actionBar-item" :inline="true" style="width:100%" v-if="type !== 'querySubCustomerList'">
              <jc-form-item :label="$t('账号：')" style="width:80%">
                <jc-input v-if="type === 'queryMyCustomerList'" v-model="form.customerPin" :placeholder="$t('请输入用户 PIN')" style="width:370px"></jc-input>
                <jc-input v-else v-model="form.distributorName" :placeholder="$t('请输入渠道商名称')" style="width:370px"></jc-input>
              </jc-form-item>
              <jc-form-item>
                <jc-button type="primary" @click="getList">{{$t('搜索')}}</jc-button>
              </jc-form-item>
            </jc-form>
      </div>
      <jc-table ref="singleTable"
       :data="tableData"
       highlight-current-row
       align="center"
       @current-change="handleCurrentChange"
       style="width: 100%"
       max-height="250"
       v-loading="loading">
       <jc-table-column label="" width="50" >
          <template scope="scope">
            <jc-radio :label="scope.$index" v-model="radio" @click="getCurrentRow(scope.$index,scope.row)"></jc-radio>
          </template>
       </jc-table-column>
        <jc-table-column :label="$t('用户 PIN')" prop="pin"></jc-table-column>
        <jc-table-column :label="$t('京东云账户名称')" prop="loginName"></jc-table-column>
        <jc-table-column v-if="type === 'getSubDistributorList'" :label="$t('渠道商名称')" prop="distributorName"></jc-table-column> 
        <jc-table-column v-if="type === 'getSubDistributorList' && !isResend"
      :label="$t('操作')"
      width="120">
      <template scope="scope">
        <jc-button @click="handleClick(scope.row)" type="text" size="small">{{$t('渠道商客户')}}</jc-button>
      </template>
    </jc-table-column>   
      </jc-table>
      <div class="jc-container-table-actionBar">
        <jc-pagination  @size-change="handleSizeChange" @current-change="handleIndexChange" :current-page="form.pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </jc-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryMyCustomerList,
  getSubDistributorList,
  querySubCustomerList
} from '@/api/coupon-api.js'
export default {
  props: ['type', 'name', 'isResend'],
  data() {
    return {
      radio: 0,
      form: {
        customerPin: '',
        distributorName: '',
        pageIndex: 1,
        pageSize: 10,
        status: 1
      },
      total: 0,
      tableData: [],
      selectedName: '',
      loading: false
    }
  },
  watch: {
    type() {
      this.getList()
    },
    selectedName(val) {
      this.$emit('selectedName', val)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        let results
        if (this.type === 'queryMyCustomerList') {
          results = await queryMyCustomerList(this.form)
        } else if (this.type === 'getSubDistributorList') {
          results = await getSubDistributorList(this.form)
        } else {
          this.form.distributorName = this.name
          results = await querySubCustomerList(this.form)
          this.form.distributorName = ''
        }
        let {
          body: { result }
        } = results
        this.total =
          (result && result.pagination && result.pagination.numberRecords) || 0
        this.tableData = result && this.handleTableData(result, result.result)
        this.radio = 0
        this.selectedName = (this.tableData[0] && this.tableData[0].pin) || ''
      } finally {
        this.loading = false
      }
    },
    getCurrentRow(index, val) {
      this.radio = index
      this.selectedName = val.pin
    },
    handleSizeChange(val) {
      this.form.pageSize = val
      this.getList()
    },
    handleIndexChange(val) {
      this.form.pageIndex = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.radio = val && val.index
      this.selectedName = val && val.pin
    },
    handleTableData(res, data) {
      let result = []
      let insertPin = !!(
        this.type === 'queryMyCustomerList' && this.form.pageIndex === 1
      ) // 我的客户列表需插入用户自己的pin
      if (insertPin && res.pin) {
        result[0] = {
          index: 0,
          pin: res.pin
        }
      }
      data &&
        data.map((item, index) => {
          index = insertPin ? index + 1 : index
          result.push({
            index,
            pin: item.pin,
            distributorName: item.distributorName,
            loginName: item.loginName
          })
        })
      if (insertPin && result.length === 1) {
        this.total = 1
      }
      return result
    },
    handleClick(row) {
      this.$emit('getSubCus', row.distributorName)
    }
  }
}
</script>
